import { FileArchive } from "lucide-react";

export const ArchiveTag = ({ testId }) => (
  <span
    className="inline-flex shrink-0 items-center gap-1 rounded-full bg-[#eaeef5] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-[#3b475c]"
    title="Archivo comprimido: no se puede previsualizar, solo descargar"
    data-testid={testId}
  >
    <FileArchive className="h-3 w-3" /> Comprimido
  </span>
);
